import { Phone } from "lucide-react";
import { track } from "../lib/api";

export default function StickyCall() {
  return (
    <a
      href="tel:0431206206"
      onClick={() => track("phone_tap", { where: "sticky" })}
      className="sm:hidden fixed bottom-4 inset-x-4 z-50 flex items-center justify-center gap-2 rounded-full bg-brand-gold px-6 py-4 font-bold text-brand-navy shadow-2xl shadow-brand-navy/30 active:scale-95 transition-transform"
      data-testid="sticky-call-btn"
    >
      <Phone className="h-5 w-5" /> Call 0431 206 206
    </a>
  );
}
